import { atom } from 'jotai';

import { FacetChipOption } from '../types';

// USE ATOMS TO PREVENT RE-RENDERING. CONTROLLED IN useGetAppliedFilterChipValues
export const allSearchPageFilterChipsAtom = atom<FacetChipOption[]>([]);
export const keywordFilterChipsAtom = atom<FacetChipOption[]>([]);
export const visibleFilterChipsAtom = atom<FacetChipOption[]>([]);

// CONTROLLED IN SEARCH PAGE HEADER
export const isInitialRenderWithResultsAtom = atom(true);
